import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const companyUsersService = {
  delete(userId, companyUserId) {
    return fetch(`/api/users/${userId}/company_users/${companyUserId}`, {
      ...request.delete
    });
  }
};
export default companyUsersService;